import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import { Account, Address, ContactPerson } from '../../types/types';

import '../../elements/langhout-button/langhout-button';
import '../langhout-beton-edit-account/langhout-beton-edit-account';
import { closeIcon } from '../../elements/icons/icons';
import { sharedStyles } from '../../elements/shared-styles';

@customElement('langhout-beton-view-account')
export class ViewAccount extends LitElement {
  static styles = [
    sharedStyles,
    css`
      :host {
        font-size: 17px;
        color: var(--text-color-main);
        height: calc(100vh - 84px);
        max-height: calc(100vh - 84px);
        overflow-y: auto;
        background-color: white;
        z-index: 100;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
      }

      .row {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
      }

      .centered {
        justify-content: center;
      }

      .inner-wrapper {
        max-width: 600px;
        flex-grow: 1;
      }

      .centered-column {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .wrapper {
        padding-bottom: 400px;
        display: flex;
        flex-direction: row;
        justify-content: center;
      }

      .close-wrapper {
        padding: 5px;
      }

      .label {
        text-align: left;
        min-width: 180px;
        font-weight: bold;
        flex-grow: 1;
        max-width: 300px;
      }

      .value {
        text-align: right;
        min-width: 100px;
        flex-grow: 1;
        max-width: 300px;
      }

      .row-inner-wrapper {
        display: flex;
        flex-direction: row;
      }

      .prod-row {
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .prod-amount {
        text-align: left;
        width: 180px;
        font-weight: bold;
      }

      .prod-name {
        text-align: left;
        min-width: 180px;
        max-width: 250px;
      }

      langhout-button {
        max-width: 150px;
        min-width: 140px;
        margin-right: 20px;
        margin-top: 20px;
      }

      .button-row {
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .action-row {
        margin-bottom: 20px;
      }

      .sub-order-wrapper {
        padding: 10px;
        border: 2px solid var(--primary-color);
        margin-top: 15px;
        border-radius: 5px;
      }

      .add-comment-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
      }

      #comment {
        min-width: 200px;
      }

      .comment-input-wrapper {
        margin-top: 20px;
      }

      .comment-wrapper {
        padding: 10px;
        border: 2px solid var(--primary-color);
        margin-top: 15px;
        border-radius: 5px;
      }

      .comment-message {
        text-align: left;
      }

      .comment-user-name,
      .comment-time {
        font-weight: bold;
        color: var(--primary-color);
      }
    `,
  ];

  @property({ type: Object, reflect: true })
  public currentViewAccount: Account = <Account>{};

  @property({ type: Boolean, reflect: true })
  private edit = false;

  constructor() {
    super();
  }

  render() {
    if (this.edit) {
      return html`
        <langhout-beton-edit-account
          .currentEditAccount=${this.currentViewAccount}
          @close=${this.dispatchCloseEvent}
          @reload=${() => {
            this.edit = false;
            this.dispatchReloadEvent();
          }}
        ></langhout-beton-edit-account>
      `;
    }
    return html`
      <div class="row">
        <div class="fill"></div>
        <div
          class="close-wrapper"
          @click="${() => {
            this.dispatchCloseEvent();
          }}"
        >
          ${closeIcon()}
        </div>
      </div>
      <div class="wrapper">
        <div class="inner-wrapper">
          <div class="row centered">
            <h2>Relatie</h2>
          </div>
          <div class="row centered display-props">
            <div class="label">Naam:</div>
            <div class="value">${this.currentViewAccount.name}</div>
          </div>
          <div class="row centered display-props">
            <div class="label">Code:</div>
            <div class="value">${this.currentViewAccount.code}</div>
          </div>
          <div class="row centered display-props">
            <div class="label">Type:</div>
            <div class="value">
              ${this.formatCustomerDescriptionType(
                this.currentViewAccount.customer_type_description,
              )}
            </div>
          </div>
          <div class="row centered display-props">
            <div class="label">Pakbon email adressen:</div>
            <div class="value">${this.renderPackageReceiptEmail()}</div>
          </div>
          <div class="row centered display-props">
            <div class="label">Factuur email adressen:</div>
            <div class="value">${this.renderInvoiceEmail()}</div>
          </div>
          <div class="row centered display-props">
            <div class="label">Pickup bevestiging email adressen:</div>
            <div class="value">${this.renderPickupConfirmationEmail()}</div>
          </div>
          <div class="row centered display-props">
            <div class="label">Automatisch pickup bevestiging versturen:</div>
            <div class="value">
              ${
                this.currentViewAccount.automatically_send_pickup_confirmation
                  ? 'Ja'
                  : 'Nee'
              }
            </div>
          </div>

          ${this.renderContact(this.currentViewAccount.contact_person)}
          ${this.renderAddress(this.currentViewAccount.address)}
          <div class="row centered">
            <langhout-button
              text="Aanpassen"
              @click="${() => {
                this.edit = true;
              }}"
            ></langhout-button>
          </div>
        </div>
      </div>
    `;
  }

  renderPackageReceiptEmail = () => {
    if (!this.currentViewAccount.package_receipt_email_addresses) {
      return html``;
    }
    return html` ${this.currentViewAccount.package_receipt_email_addresses.map(
      v => {
        return html` <div>${v}</div>`;
      },
    )}`;
  };

  renderInvoiceEmail = () => {
    if (!this.currentViewAccount.invoice_email_addresses) {
      return html``;
    }
    return html` ${this.currentViewAccount.invoice_email_addresses.map(v => {
      return html` <div>${v}</div>`;
    })}`;
  };

  renderPickupConfirmationEmail = () => {
    if (!this.currentViewAccount.pickup_confirmation_email_addresses) {
      return html``;
    }
    return html`
      ${this.currentViewAccount.pickup_confirmation_email_addresses.map(v => {
        return html` <div>${v}</div>`;
      })}
    `;
  };

  renderContact = (contact: ContactPerson) => {
    if (!contact) {
      return html``;
    }
    return html`
      <div class="row centered">
        <h2>Contact</h2>
      </div>
      <div class="row centered display-props">
        <div class="label">Naam:</div>
        <div class="value">
          ${contact.first_name} ${contact.middle_name} ${contact.last_name}
        </div>
      </div>
      <div class="row centered display-props">
        <div class="label">Email:</div>
        <div class="value">${contact.email_address}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Telefoonnummer:</div>
        <div class="value">${contact.phone_number}</div>
      </div>
    `;
  };

  renderAddress = (address: Address) => {
    if (!address) {
      return html``;
    }
    return html` <div class="row centered">
        <h2>Aflever Adres</h2>
      </div>
      <div class="row centered display-props">
        <div class="label">Code:</div>
        <div class="value">${address.address_code}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Adres:</div>
        <div class="value">${address.address}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Plaats:</div>
        <div class="value">${address.city}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Postcode:</div>
        <div class="value">${address.post_code}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Provincie:</div>
        <div class="value">${address.state_description}</div>
      </div>
      <div class="row centered display-props">
        <div class="label">Land:</div>
        <div class="value">${address.country}</div>
      </div>`;
  };

  formatCustomerDescriptionType = (descType: string): string => {
    if (descType === 'Supplier') {
      return 'Leverancier';
    }
    return 'Klant';
  };

  dispatchReloadEvent = () => {
    const event = new CustomEvent('reload', {
      detail: {},
    });
    this.dispatchEvent(event);
  };

  dispatchCloseEvent = () => {
    this.edit = false;
    const event = new CustomEvent('close', {
      detail: {},
    });
    this.dispatchEvent(event);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-view-account': ViewAccount;
  }
}
